// Generated by purs version 0.14.5
"use strict";
var $foreign = require("./foreign.js");
var Data_Unit = require("../Data.Unit/index.js");
var icon = $foreign.foreignIcon(Data_Unit.unit);
module.exports = {
    icon: icon
};
